import { render, staticRenderFns } from "./zhaoshengjianzhang_mobile.vue?vue&type=template&id=015d304a&scoped=true"
import script from "./zhaoshengjianzhang_mobile.vue?vue&type=script&lang=js"
export * from "./zhaoshengjianzhang_mobile.vue?vue&type=script&lang=js"
import style0 from "./zhaoshengjianzhang_mobile.vue?vue&type=style&index=0&id=015d304a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d304a",
  null
  
)

export default component.exports